import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ActiveDropState } from "@/types/dropInteractionTypes";
import { useDropPrivileges } from "@/hooks/useDropPriviledges";
import { useAuth } from "../auth/Auth";
import DropPlaceholder from "./DropPlaceholder";
import CreateDrop from "./CreateDrop";
export enum DropMode {
  CHAT = "CHAT",
  PARTICIPATION = "PARTICIPATION",
  BOTH = "BOTH",
}
export type CurationComposerVariant = "default" | "leaderboard";
interface PrivilegedDropCreatorProps {
  readonly activeDrop: ActiveDropState | null;
  readonly onCancelReplyQuote: () => void;
  readonly onDropAddedToQueue: () => void;
  readonly onAllDropsAdded?: (() => void) | undefined;
  readonly wave: ApiWave;
  readonly dropId: string | null;
  readonly fixedDropMode: DropMode;
  readonly curationComposerVariant?: CurationComposerVariant | undefined;
}
export default function PrivilegedDropCreator(t0) {
  const $ = _c(30);
  const {
    activeDrop,
    onCancelReplyQuote,
    wave,
    dropId,
    fixedDropMode,
    onAllDropsAdded,
    onDropAddedToQueue,
    curationComposerVariant: t1
  } = t0;
  const curationComposerVariant = t1 === undefined ? "default" : t1;
  const {
    connectedProfile,
    activeProfileProxy
  } = useAuth();
  const t2 = !!connectedProfile?.handle;
  const t3 = !!activeProfileProxy;
  const t4 = !wave.chat.enabled;
  const t5 = wave.participation.period?.min ?? null;
  const t6 = wave.participation.period?.max ?? null;
  const t7 = wave.participation.no_of_applications_allowed_per_participant ?? null;
  const t8 = wave.metrics.your_participation_drops_count ?? null;
  let t9;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4 || $[3] !== t5 || $[4] !== t6 || $[5] !== t7 || $[6] !== t8 || $[7] !== wave.chat.authenticated_user_eligible || $[8] !== wave.participation.authenticated_user_eligible) {
    t9 = {
      isLoggedIn: t2,
      isProxy: t3,
      canChat: wave.chat.authenticated_user_eligible,
      canDrop: wave.participation.authenticated_user_eligible,
      chatDisabled: t4,
      submissionStarts: t5,
      submissionEnds: t6,
      maxDropsCount: t7,
      identityDropsCount: t8
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
    $[5] = t7;
    $[6] = t8;
    $[7] = wave.chat.authenticated_user_eligible;
    $[8] = wave.participation.authenticated_user_eligible;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const {
    submissionRestriction,
    chatRestriction
  } = useDropPrivileges(t9);
  if (!!submissionRestriction && !!chatRestriction) {
    let t10;
    if ($[10] !== chatRestriction || $[11] !== submissionRestriction) {
      t10 = <DropPlaceholder type="both" chatRestriction={chatRestriction} submissionRestriction={submissionRestriction} />;
      $[10] = chatRestriction;
      $[11] = submissionRestriction;
      $[12] = t10;
    } else {
      t10 = $[12];
    }
    return t10;
  }
  if (fixedDropMode === DropMode.CHAT && !!chatRestriction) {
    let t10;
    if ($[13] !== chatRestriction) {
      t10 = <DropPlaceholder type="chat" chatRestriction={chatRestriction} />;
      $[13] = chatRestriction;
      $[14] = t10;
    } else {
      t10 = $[14];
    }
    return t10;
  }
  if (fixedDropMode === DropMode.PARTICIPATION && !!submissionRestriction) {
    let t10;
    if ($[15] !== submissionRestriction) {
      t10 = <DropPlaceholder type="submission" submissionRestriction={submissionRestriction} />;
      $[15] = submissionRestriction;
      $[16] = t10;
    } else {
      t10 = $[16];
    }
    return t10;
  }
  let t10;
  if ($[17] !== chatRestriction || $[18] !== submissionRestriction) {
    t10 = {
      submissionRestriction,
      chatRestriction
    };
    $[17] = chatRestriction;
    $[18] = submissionRestriction;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== activeDrop || $[21] !== curationComposerVariant || $[22] !== dropId || $[23] !== fixedDropMode || $[24] !== onAllDropsAdded || $[25] !== onCancelReplyQuote || $[26] !== onDropAddedToQueue || $[27] !== t10 || $[28] !== wave) {
    t11 = <CreateDrop activeDrop={activeDrop} onCancelReplyQuote={onCancelReplyQuote} onAllDropsAdded={onAllDropsAdded} wave={wave} dropId={dropId} fixedDropMode={fixedDropMode} privileges={t10} onDropAddedToQueue={onDropAddedToQueue} curationComposerVariant={curationComposerVariant} />;
    $[20] = activeDrop;
    $[21] = curationComposerVariant;
    $[22] = dropId;
    $[23] = fixedDropMode;
    $[24] = onAllDropsAdded;
    $[25] = onCancelReplyQuote;
    $[26] = onDropAddedToQueue;
    $[27] = t10;
    $[28] = wave;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
}